import { Alert } from "@blueprintjs/core";
import { useState } from "react";
import { hasDirtyComponents } from "lib/util/ComponentController";
import { UnsavedWorkAlert } from "./UnsavedWorkAlert";

type SignoutAlertProps = {
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
};

export const SignoutAlert = ({
  onConfirm,
  onCancel,
  message = "Do you want to sign out?",
}: SignoutAlertProps) => {
  const [showWarning] = useState(hasDirtyComponents);

  if (!showWarning) {
    return (
      <Alert
        style={{ fontSize: 14 }}
        isOpen
        cancelButtonText="Cancel"
        confirmButtonText="Sign Out"
        onConfirm={onConfirm}
        onCancel={onCancel}
        intent="primary"
      >
        {message}
      </Alert>
    );
  }

  return (
    <UnsavedWorkAlert
      action="sign out"
      message={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
